
const Highlights = () => {
    return (
     <h1>Highlights</h1>
    );

}

export default Highlights;